'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _circularProgress = require('material-ui/lib/circular-progress');

var _circularProgress2 = _interopRequireDefault(_circularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spinner = function (_Component) {
  _inherits(Spinner, _Component);

  function Spinner(props) {
    _classCallCheck(this, Spinner);

    var _this = _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call(this, props));

    if (_this.props.hideafter) {
      setTimeout(function () {
        if (_this.refs.spinner && _this.refs.spinner.style) {
          _this.refs.spinner.style.display = 'none';
        }
      }, 30000);
    }
    return _this;
  }

  _createClass(Spinner, [{
    key: 'render',
    value: function render() {
      var styles = require('./Spinner.scss');
      var loading = this.props.loading ? this.props.loading : true;
      var _props = this.props,
          style = _props.style,
          inline = _props.inline,
          inlinefull = _props.inlinefull;


      return _react2.default.createElement(
        'div',
        { ref: 'spinner' },
        loading && !inline && !inlinefull && _react2.default.createElement(
          'div',
          { style: style, className: styles.binary_spinner },
          _react2.default.createElement(_circularProgress2.default, { size: 1, color: '#FF7052' })
        ),
        loading && inline && _react2.default.createElement(_circularProgress2.default, { style: style, size: 0.5, color: '#FF7052' }),
        loading && inlinefull && _react2.default.createElement(
          'div',
          { style: style, className: styles.binary_spinner_inline },
          _react2.default.createElement(_circularProgress2.default, { size: 0.5, color: '#FF7052' })
        )
      );
    }
  }]);

  return Spinner;
}(_react.Component);

Spinner.propTypes = {
  loading: _propTypes2.default.bool,
  inline: _propTypes2.default.bool,
  inlinefull: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  hideafter: _propTypes2.default.bool
};
Spinner.defaultProps = {
  inline: false,
  inlinefull: false,
  style: { zIndex: 999999 },
  hideafter: false
};
exports.default = Spinner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/Spinner/Spinner.js
// module id = 2133
// module chunks = 1